import script from "./Editor.vue?vue&type=script&lang=ts&setup=true"
export * from "./Editor.vue?vue&type=script&lang=ts&setup=true"

import "./Editor.vue?vue&type=style&index=0&id=0ebc507c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebc507c"]])

export default __exports__